import { get } from 'lodash';
import { useContext } from 'react';
import { BankType } from '../../generated/graphql';
import { getDictionary } from '../utils/getDictionary';
import { compose } from '../utils/pipes';
import { useBankContext, useBrandContext } from './BankContext';
import { CountryContext } from './CountryContext';
import { DictionaryContextType } from './DictionaryContextTypes';

const useDictionary = () => {
  const [ brand ] = useBrandContext();
  const [ bank ] = useBankContext();
  const { countrySelected } = useContext(CountryContext);
  const dictionary = getDictionary(countrySelected, brand, bank as BankType);

  const applyPipes = (value: string, context: DictionaryContextType) => {
    const variables = value.split('%').join('').split('|');
    const pipes = variables.slice(1);
    const contextKey = variables[0];
    const contextValue = get(context, contextKey, contextKey);
    if (pipes.length >= 1) return compose(pipes)(contextValue);
    return contextValue;
  };

  const transformData = (value: string, context?: DictionaryContextType) => {
    if (!context || Object.keys(context).length === 0 || !value) return value;
    const generalPipe = value.match(/~.+?~/gm);
    const newValue = !!generalPipe ? value
      .split('\n')
      .filter((v) => (context.hidden ? !generalPipe.includes(v) : v))
      .join('\n') : value;
    const vars = newValue.match(/%.+?%/gm);
    if (!vars || vars?.length === 0) return newValue;
    return vars?.reduce(
      (prev, curr) => prev.replace(curr, applyPipes(curr, context)?.toString() ?? ''),
      newValue,
    );
  };

  const getValue = (key: string): string => {
    const value = dictionary[key];
    if (typeof value === 'object') return value;
    if ((value || '')[0] === '^') {
      if ((value || '').includes('++')) {
        const additionalValue = value.split('++')[1];
        const copyValue = dictionary[value.slice(1).split('++')[0]];
        if (copyValue !== undefined && additionalValue) return copyValue.concat(additionalValue);
      }
      const copyValue = dictionary[value.slice(1)];
      if (copyValue !== undefined) return copyValue;
    }
    return value;
  };

  const gT = (key: string, context?: DictionaryContextType) => {
    const value = getValue(key);

    // eslint-disable-next-line no-console
    if (!value) console.info('empty key', key);

    if (value === undefined) {
      return '';
    }
    if (typeof value === 'object') {
      return transformData(
        context?.isSingular !== undefined
          ? value[context?.isSingular ? 'singular' : 'plural']
          : value,
        context,
      );
    }

    return transformData(value, context);
  };

  return {
    dictionary,
    gT,
  };
};

export default useDictionary;
